import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-6 col-md-3 mb-3"
}
const _hoisted_3 = {
  key: 1,
  class: "col-6 col-md-3 mb-3"
}
const _hoisted_4 = {
  key: 2,
  class: "col-6 col-md-3 mb-3"
}
const _hoisted_5 = {
  key: 3,
  class: "col-6 col-md-3 mb-3"
}
const _hoisted_6 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_7 = {
  key: 1,
  class: "row"
}
const _hoisted_8 = { class: "col-6 col-md-4 col-xl-2 mb-3" }
const _hoisted_9 = { class: "card h-100" }
const _hoisted_10 = { class: "card-body text-center" }
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = { class: "col-6 col-md-4 col-xl-2 mb-3" }
const _hoisted_13 = { class: "card h-100" }
const _hoisted_14 = { class: "card-body text-center" }
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { class: "col-6 col-md-4 col-xl-2 mb-3" }
const _hoisted_17 = { class: "card h-100" }
const _hoisted_18 = { class: "card-body text-center" }
const _hoisted_19 = { class: "fs-13 text-muted" }
const _hoisted_20 = { class: "fw-bold" }
const _hoisted_21 = { class: "col-6 col-md-4 col-xl-2 mb-3" }
const _hoisted_22 = { class: "card h-100" }
const _hoisted_23 = { class: "card-body text-center" }
const _hoisted_24 = { class: "fw-bold" }
const _hoisted_25 = { class: "col-6 col-md-4 col-xl-2 mb-3" }
const _hoisted_26 = { class: "card h-100" }
const _hoisted_27 = { class: "card-body text-center" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "col-6 col-md-4 col-xl-2 mb-3" }
const _hoisted_30 = { class: "card h-100" }
const _hoisted_31 = { class: "card-body text-center" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = {
  key: 2,
  class: "row"
}
const _hoisted_34 = { class: "col-md-8 mb-3" }
const _hoisted_35 = { class: "card h-100" }
const _hoisted_36 = { class: "card-body" }
const _hoisted_37 = { class: "col-md-4 mb-3" }
const _hoisted_38 = { class: "card h-100" }
const _hoisted_39 = { class: "card-body" }
const _hoisted_40 = {
  key: 3,
  class: "row"
}
const _hoisted_41 = { class: "col-md-6 mb-3" }
const _hoisted_42 = { class: "card h-100" }
const _hoisted_43 = { class: "card-body" }
const _hoisted_44 = { class: "col-md-6 mb-3" }
const _hoisted_45 = { class: "card h-100" }
const _hoisted_46 = { class: "card-body" }

import { reactive, onMounted, computed } from "vue";

import { useUserStore } from "@/stores/userStore";
import Notificacao from "@/components/Notificacao/Index.vue";
import * as dashboardService from "@/services/dashboardService";
import { f2dec } from "@/utils/funcoes";


export default /*@__PURE__*/_defineComponent({
  __name: 'EcommercePage',
  setup(__props) {


const userStore = useUserStore();

var controle = reactive({
  atualizando: false,
  status: "",
  erro: "",
  dados: null as dashboardService.Dashboard | null,
})

onMounted(() => {
  carregar();
})

function carregar() {
  controle.status = "Carregando...";
  controle.erro = "";

  dashboardService.obter()
    .then((r) => {
      controle.dados = r;
      controle.status = "";
    })
    .catch((e) => {
      controle.erro = e.message || String(e);
      controle.status = "";
    });
}

const graficoPrevisao = computed(() => ({
  options: {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: { bar: { columnWidth: "45%", borderRadius: 4 } },
    dataLabels: { enabled: false },
    colors: ["#9C9AB6", "#0c911b"],
    xaxis: { categories: controle.dados?.previsaoMensal.map(a => a.mes) ?? [] },
    yaxis: { labels: { formatter: (v: number) => "R$ " + f2dec(v) } },
    legend: { position: "top" },
    grid: { strokeDashArray: 5, borderColor: "#eee" },
    tooltip: { y: { formatter: (v: number) => "R$ " + f2dec(v) } },
  },
  series: [
    { name: "Previsto", data: controle.dados?.previsaoMensal.map(a => a.previsto) ?? [] },
    { name: "Recebido", data: controle.dados?.previsaoMensal.map(a => a.recebido) ?? [] },
  ],
}));

const graficoSituacao = computed(() => ({
  options: {
    chart: { type: "donut" },
    labels: controle.dados?.situacaoMensalidadesMes.map(a => a.nome) ?? [],
    colors: ["#06B48A", "#6560F0", "#F04D6A"],
    legend: { position: "bottom" },
    dataLabels: { enabled: false },
    tooltip: { y: { formatter: (v: number) => "R$ " + f2dec(v) } },
  },
  series: controle.dados?.situacaoMensalidadesMes.map(a => a.valor) ?? [],
}));

const graficoNovosClientes = computed(() => ({
  options: {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: { bar: { columnWidth: "40%", borderRadius: 4 } },
    dataLabels: { enabled: true },
    colors: ["#6560F0"],
    xaxis: { categories: controle.dados?.novosClientesPorMes.map(a => a.mes) ?? [] },
    grid: { strokeDashArray: 5, borderColor: "#eee" },
  },
  series: [{ name: "Novos clientes", data: controle.dados?.novosClientesPorMes.map(a => a.qtde) ?? [] }],
}));

const graficoTopCidades = computed(() => ({
  options: {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: "55%" } },
    dataLabels: { enabled: true, formatter: (v: number) => "R$ " + f2dec(v) },
    colors: ["#0c911b"],
    xaxis: { categories: controle.dados?.topCidades.map(a => a.nome) ?? [] },
    grid: { strokeDashArray: 5, borderColor: "#eee" },
  },
  series: [{ name: "Recebido no mês", data: controle.dados?.topCidades.map(a => a.valor) ?? [] }],
}));


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Notificacao, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro = '')),
      progresso: _unref(controle).status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createElementVNode("div", _hoisted_1, [
      (_unref(userStore).hasPermissao('clientes'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_RouterLink, {
              to: "/clientes",
              class: "botao-home d-flex flex-column align-items-center justify-content-center text-white"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fa fa-users" }, null, -1),
                _createElementVNode("span", null, "Clientes", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(userStore).hasPermissao('empresas'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_RouterLink, {
              to: "/empresas",
              class: "botao-home d-flex flex-column align-items-center justify-content-center text-white"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "fa fa-building" }, null, -1),
                _createElementVNode("span", null, "Empresas", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(userStore).hasPermissao('parceiros'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              to: "/parceiros",
              class: "botao-home d-flex flex-column align-items-center justify-content-center text-white"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "fa fa-handshake" }, null, -1),
                _createElementVNode("span", null, "Parceiros", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(userStore).hasPermissao('contasReceber'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: "/contasReceber",
              class: "botao-home d-flex flex-column align-items-center justify-content-center text-white"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "fa fa-file-invoice-dollar" }, null, -1),
                _createElementVNode("span", null, "Contas a Receber", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "divisoria-dashboard" }, [
      _createElementVNode("span", null, "Em Construção")
    ], -1)),
    (!_unref(controle).dados)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("i", { class: "fa fa-spinner fa-spin fs-2 text-muted" }, null, -1),
          _createElementVNode("div", { class: "text-muted mt-2" }, "Carregando dashboard...", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_unref(controle).dados)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fa fa-money-bill-wave fs-4 text-success mb-2" }, null, -1)),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "fs-13 text-muted" }, "Recebido no mês", -1)),
                _createElementVNode("div", _hoisted_11, "R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).dados.totalRecebidoMes)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-hand-holding-usd fs-4 text-primary mb-2" }, null, -1)),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fs-13 text-muted" }, "A receber no mês", -1)),
                _createElementVNode("div", _hoisted_15, "R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).dados.totalAReceberMes)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-exclamation-triangle fs-4 text-danger mb-2" }, null, -1)),
                _createElementVNode("div", _hoisted_19, "Atrasado (" + _toDisplayString(_unref(controle).dados.qtdeParcelasAtrasadas) + ")", 1),
                _createElementVNode("div", _hoisted_20, "R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).dados.totalAtrasado)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-file-contract fs-4 text-info mb-2" }, null, -1)),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "fs-13 text-muted" }, "Contratos ativos", -1)),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(controle).dados.qtdeContratosAtivos), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa fa-users fs-4 text-secondary mb-2" }, null, -1)),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "fs-13 text-muted" }, "Clientes ativos", -1)),
                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(controle).dados.qtdeClientesAtivos), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-user-plus fs-4 text-success mb-2" }, null, -1)),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "fs-13 text-muted" }, "Novos clientes no mês", -1)),
                _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(controle).dados.qtdeClientesNovosMes), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(controle).dados)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[18] || (_cache[18] = _createElementVNode("h6", { class: "card-title fw-bold" }, "Previsto x Recebido (últimos 6 meses)", -1)),
                _createVNode(_component_apexchart, {
                  type: "bar",
                  height: "300",
                  options: graficoPrevisao.value.options,
                  series: graficoPrevisao.value.series
                }, null, 8, ["options", "series"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _cache[19] || (_cache[19] = _createElementVNode("h6", { class: "card-title fw-bold" }, "Situação das parcelas do mês", -1)),
                _createVNode(_component_apexchart, {
                  type: "donut",
                  height: "300",
                  options: graficoSituacao.value.options,
                  series: graficoSituacao.value.series
                }, null, 8, ["options", "series"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(controle).dados)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[20] || (_cache[20] = _createElementVNode("h6", { class: "card-title fw-bold" }, "Novos clientes por mês", -1)),
                _createVNode(_component_apexchart, {
                  type: "bar",
                  height: "280",
                  options: graficoNovosClientes.value.options,
                  series: graficoNovosClientes.value.series
                }, null, 8, ["options", "series"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _cache[21] || (_cache[21] = _createElementVNode("h6", { class: "card-title fw-bold" }, "Top 5 cidades - recebido no mês", -1)),
                _createVNode(_component_apexchart, {
                  type: "bar",
                  height: "280",
                  options: graficoTopCidades.value.options,
                  series: graficoTopCidades.value.series
                }, null, 8, ["options", "series"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})